// Mirrors FactoringFundingRequest.TYPE_CHOICES in the backend
// (factoring/models/__init__.py, BaseFundingRequest). Values are the
// strings stored on funding_request.contract_type — the same set the
// freeze-exempt API validates against. Do NOT unify with the 6-value
// `fundingRequestType` constant in FactoringProfileDetailsCard.js;
// that one uses different ID conventions (STD_BROKER vs. STANDARD_*)
// for the Enable/Disable Funding Request Types feature, which is a
// different domain.

export interface ContractTypeOption {
  value: string;
  text: string;
  header: string;
}

const HEADER_STANDARD = "Standard Funding Request";
const HEADER_NON_FACTORED = "Non Factored Funding Requests";
const HEADER_SELF_FINANCE = "Self Finance Funding Request";

export const ALL_CONTRACT_TYPES: ContractTypeOption[] = [
  { value: "STD_CARRIER", text: "Standard Carrier", header: HEADER_STANDARD },
  { value: "STD_BROKER", text: "Standard Broker", header: HEADER_STANDARD },
  { value: "MEMO", text: "Memo", header: HEADER_STANDARD },
  {
    value: "NON_FACTORED_STANDARD",
    text: "Non-Factored Pay Carrier",
    header: HEADER_NON_FACTORED
  },
  {
    value: "NON_FACTORED_BILL_OUT",
    text: "Non-Factored Bill Out Only",
    header: HEADER_NON_FACTORED
  },
  {
    value: "NON_FACTORED_PAYMENT_FORWARD",
    text: "Payment Forward",
    header: HEADER_NON_FACTORED
  },
  {
    value: "SELF_FINANCE_NO_INVOICE",
    text: "Self Finance No Invoice",
    header: HEADER_SELF_FINANCE
  },
  {
    value: "SELF_FINANCE_WITH_INVOICE",
    text: "Self Finance With Invoice",
    header: HEADER_SELF_FINANCE
  },
  {
    value: "SELF_FINANCE_WITH_INVOICE_OFF_PLATFORM",
    text: "Self Finance With Invoice (Off-Platform)",
    header: HEADER_SELF_FINANCE
  },
  {
    value: "SELF_FINANCE_LEDGER_DEPOSIT",
    text: "Self Finance Ledger Deposit",
    header: HEADER_SELF_FINANCE
  },
  {
    value: "SELF_FINANCE_STRIPE_DEPOSIT",
    text: "Self Finance Stripe Deposit",
    header: HEADER_SELF_FINANCE
  }
];

export const CONTRACT_TYPE_LABEL: Record<string, string> = ALL_CONTRACT_TYPES.reduce(
  (acc, { value, text }) => {
    acc[value] = text;
    return acc;
  },
  {} as Record<string, string>
);
